export const getPrecedingZero = (number: number | string) => {
  return +number === 0 ? 0 :
    (+number > -10 && +number < 10) ?
      ('0' + +number).slice(-2) : +number;
}